<template>
  <nav class="abas-detalhes-solicitacao">
    <button
      type="button"
      role="tab"
      :aria-selected="abaSelecionada === 'visao-geral'"
      @click="$emit('update:abaSelecionada', 'visao-geral')"
      @click.prevent="$emit('update:abaSelecionada', 'visao-geral')"
      :class="[
        'abas-detalhes-solicitacao__item',
        {
          'abas-detalhes-solicitacao__item_selecionado':
            abaSelecionada === 'visao-geral',
        },
      ]"
    >
      Visão geral
    </button>
    <button
      type="button"
      role="tab"
      :aria-selected="abaSelecionada === 'linha-do-tempo'"
      @click="$emit('update:abaSelecionada', 'linha-do-tempo')"
      :class="[
        'abas-detalhes-solicitacao__item',
        {
          'abas-detalhes-solicitacao__item_selecionado':
            abaSelecionada === 'linha-do-tempo',
        },
      ]"
    >
      Linha do tempo ({{ totalDeItensNaLinhaDoTempo }})
    </button>
  </nav>
</template>

<script>
export default {
  name: "abas-detalhes-solicitacao",
  props: {
    abaSelecionada: { type: String, required: true },
    totalDeItensNaLinhaDoTempo: { type: Number, default: 0 },
  },
};
</script>



// WEBPACK FOOTER //
// AbasDetalhesSolicitacao.vue?ab2dda5e